export default {
  mediaChannel: 'Canal de Medios',
  allChannels: 'Todos los Canales',
  addNewRestriction: 'Agregar Nueva Restricción',
  newRestrictionTitle: 'Nueva Restricción',
  restrictionType: 'Tipo de Restricción',
  exactly: 'Igual',
  lessThan: 'Menor o igual',
  moreThan: 'Mayor o igual',
  between: 'Entre',
  value: 'Valor',
  minValue: 'Mín',
  maxValue: 'Máx',
  restrictionTimespan: 'Período de Restricción',
  fullPeriod: 'Período Completo',
  customRange: 'Rango Personalizado',
  fromDate: 'Desde',
  toDate: 'Hasta',
  addRestriction: 'Agregar Restricción',
  editRestrictionTitle: 'Editar Restricción',
  saveRestriction: 'Guardar',
  edit: 'Editar',
  delete: 'Eliminar',
  cancel: 'Cancelar',
  duplicateError: 'Ya existe una restricción idéntica para estos canales y este período',
  combinedRestriction: 'Restricción combinada para: {channels}',
  valueMustBeNonNegative: 'El valor no puede ser negativo',
  maxMustBeGreaterThanMin: 'El máximo debe ser mayor que el mínimo',
  mediaChannelRequired: 'Por favor selecciona al menos un canal de medios',
  selectDateRange: 'Por favor selecciona un rango de fechas',
  fromDateMustBeBeforeToDate: 'La fecha de inicio debe ser anterior a la fecha de fin'
}
